import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Login from "./pages/login/Login";
import TopNav from "./components/TopNav";
import Dashboard from "./pages/dashboard/Dashboard";
import ForgotPasswordPage from "./pages/login/ForgotPasswordPage";
import ResetPasswordPage from './pages/login/ResetPasswordPage';
import "bootstrap/dist/css/bootstrap.min.css";

import UserManagement from "./pages/userManagement/UserManagement";
import ManageRole from "./pages/manageRole/ManageRole";
import ManagePackage from "./pages/managePackage/ManagePackage";
import ManageProduct from "./pages/manageProduct/ManageProduct";
import ManageCampaign from "./pages/manageCampaign/ManageCampaign";
import ViewOrder from "./pages/orderManagement/ViewOrder";
import ViewSales from "./pages/orderManagement/ViewSales";
import ViewEsim from "./pages/orderManagement/ViewEsim";
import DashboardHome from "./pages/dashboard/DashboardHome";

import { ROUTES } from "./utils/constant";

//css
import "./App.css";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('access_token');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  return (
    <Router>
      <TopNav />

      <div style={{ height: 'calc(100vh - 50px)', overflow: 'hidden' }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/login/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardHome />} />
            <Route path={ROUTES.USER_MANAGEMENT.replace('/dashboard/', '')} element={<UserManagement />} />
            <Route path="user-management/create" element={<UserManagement />} />
            <Route path="user-management/edit/:userId" element={<UserManagement />} />
            <Route path="user-management/view/:userId" element={<UserManagement />} />

            <Route path={ROUTES.ROLE_AND_PERMISSION.replace('/dashboard/', '')} element={<ManageRole />} />
            <Route path="role-and-permission/create" element={<ManageRole />} />
            <Route path="role-and-permission/edit/:roleId" element={<ManageRole />} />
            <Route path="role-and-permission/view/:roleId" element={<ManageRole />} />

            <Route path={ROUTES.MANAGE_PACKAGE.replace('/dashboard/', '')} element={<ManagePackage />} />
            <Route path="manage-package/create" element={<ManagePackage />} />
            <Route path="manage-package/edit/:packageId" element={<ManagePackage />} />

            <Route path={ROUTES.MANAGE_PRODUCT.replace('/dashboard/', '')} element={<ManageProduct />} />
            <Route path="manage-product/create" element={<ManageProduct />} />
            <Route path="manage-product/edit/:productId" element={<ManageProduct />} />

            <Route path={ROUTES.MANAGE_CAMPAIGN.replace('/dashboard/', '')} element={<ManageCampaign />} />
            <Route path="manage-campaign/create" element={<ManageCampaign />} />
            <Route path="manage-campaign/edit/:campaignId" element={<ManageCampaign />} />

            <Route path={ROUTES.VIEW_ORDER.replace('/dashboard/', '')} element={<ViewOrder />} />
            <Route path={ROUTES.VIEW_SALES.replace('/dashboard/', '')} element={<ViewSales />} />
            <Route path={ROUTES.VIEW_ESIM.replace('/dashboard/', '')} element={<ViewEsim />} />
          </Route>

          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;